export default __webpack_public_path__ + "static/media/logo.ae8c51ff.png";